<template>
    <div>
        <template>
            <StepHeader
                :subtitle="step.subtitle"
                :description="step.description"
            />
            <div class="d-flex flex-wrap flex-column">
                <div
                    class="pa-2 input-file"
                    style="width: 100%;"
                >
                    <v-text-field
                        filled
                        class='text-truncate'
                        v-model="defaultFilename"
                        :rules="[() => (!!defaultFilename) || $t('habiteoStudio.mandatoryField')]"
                        :placeholder="step.forms[0].inputs[0].fields[0].placeholder"
                    />
                </div>
                <v-row
                    dense
                    no-gutters
                    class="pb-4"
                >
                    <span class="green-text text-darken-2 pb-3">
                        {{ $t('habiteoStudio.instructions') }}
                    </span>
                    <ul>
                        <li class="h5 text-darken-2 green-text">
                            <div class='d-flex'>
                                {{ isAProgram ? $t('habiteoStudio.instructionImportFromProgram') : $t('habiteoStudio.instructionImportFromPlot')}}
                                <v-icon 
                                    right 
                                    class='green-text'
                                    size="95%"
                                    @click="togglePopUp"
                                >
                                    mdi-help-circle-outline
                                </v-icon>
                                <HelpImportationExemple
                                    :showPopUp="showPopUp"
                                    :isAProgram="isAProgram"
                                    @toggle-pop-up="togglePopUp"
                                />
                            </div>
                        </li>
                        <li class="h5 text-darken-2 green-text">
                            <span>
                                {{ $t('habiteoStudio.instructionDownload') }}
                            </span>
                        </li>
                    </ul>
                </v-row>
            </div>
        </template>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import StepHeader from '@/components/myHabiteoStudio/steps/components/StepHeader';
    import HelpImportationExemple from '@/components/myHabiteoStudio/steps/components/HelpImportationExemple';

    export default {
        name: 'StepExport',
        components: {
            StepHeader,
            HelpImportationExemple
        },
        props: {
            step: {
                type: Object,
                required: true
            },
            steps: {
                type: Array,
                required: true
            },
            selectedValues: {
                type: Object,
                required: true
            },
            widgetName: {
                type: String,
                required: true
            },
            programName: {
                type: String,
                required: true
            },
            isAProgram: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                filename: '',
                illustration: null,
                showPopUp: false
            }
        },
        computed: {
            mediaType() {
                return this.$props.steps && this.$props.steps.find(step => step.id === 'step_1')? this.$props.steps.find(step => step.id === 'step_1').forms[0].inputs[0].fields.find(field => this.$props.selectedValues.media === field.value).label.replace(/ /g, "") : null;
            },
            format() {
                return this.$props.steps && this.$props.steps.find(step => step.id === 'step_2') ? this.$props.steps.find(step => step.id === 'step_2').forms[0].inputs[0].fields.find(field => this.$props.selectedValues.format === field.value).label.replace(/ /g, "") : null;
            },
            quality() {
                return this.$props.steps && this.$props.steps.find(step => step.id === 'step_3') ? this.$props.steps.find(step => step.id === 'step_3').forms[1].inputs[0].fields.find(field => this.$props.selectedValues.quality === field.value).label.replace(/ /g, "") : null;
            },
            defaultFilename: {
                get () {
                    return this.filename ? this.filename : '';
                },
                set (val) {
                    this.filename = val
                }
            }
        },
        mounted() {
            this.filename = this.$props.programName && this.$props.widgetName ?  this.$props.programName.replace(' ', '_').toLowerCase() + '_' + this.$props.widgetName.replace(' ', '_').toLowerCase() : this.mediaType.toLowerCase();
    },
        methods: {
            togglePopUp() {
                this.showPopUp = !this.showPopUp;
            },
        },
        watch: {
            filename(name) {
                this.$props.step.forms[0].inputs[0].value = name.trim();
                EventBus.$emit('setFilename', name.trim());
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/StepExport.vue